import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { RequestParam } from '@core/models/request-params.model';
import { ComboValue } from './../../models/combo-values.model';

@Injectable()
export class ValuesService {
  constructor(private http: HttpClient) {}

  getValues(
    endPoint: string,
    requestParams?: RequestParam[]
  ): Observable<ComboValue[]> {
    let params = new HttpParams();

    if (requestParams) {
      requestParams.forEach(
        (param: RequestParam) =>
          (params = params.append(param.param, param.value))
      );
    }

    return this.http.get<ComboValue[]>(`values/${endPoint}`, { params });
  }
}
